exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-components-checkout-steps-___base-checkout-layout__delivery_small_text___2iWLa{font-size:12px;line-height:1.5;color:#828282;font-style:italic}", ""]);

// exports
exports.locals = {
	"delivery_small_text": "src-components-styles-components-checkout-steps-___base-checkout-layout__delivery_small_text___2iWLa"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/components/checkout-steps/base-checkout-layout.scss
 ** module id = 906
 ** module chunks = 0
 **/